/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Notifications_Enablepushdescription3Inputs */

const id_offerdetail_notifications_enablepushdescription3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda perlu mengaktifkan notifikasi push untuk menerima notifikasi penawaran ini.`)
};

const ms_offerdetail_notifications_enablepushdescription3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda perlu mengaktifkan pemberitahuan push untuk menerima pemberitahuan bagi tawaran ini.`)
};

const da_offerdetail_notifications_enablepushdescription3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du skal aktivere push-notifikationer for at modtage notifikationer for dette tilbud.`)
};

const de_offerdetail_notifications_enablepushdescription3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie müssen Push-Benachrichtigungen aktivieren, um Benachrichtigungen für dieses Angebot zu erhalten.`)
};

const en_us2_offerdetail_notifications_enablepushdescription3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You need to enable push notifications to receive notifications for this offer.`)
};

const es_es2_offerdetail_notifications_enablepushdescription3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Necesitas habilitar las notificaciones push para recibir notificaciones de este contenido.`)
};

const es_mx2_offerdetail_notifications_enablepushdescription3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Necesitas habilitar las notificaciones push para recibir notificaciones de esta oferta.`)
};

const fil_offerdetail_notifications_enablepushdescription3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kailangan mong i-enable ang push notifications para makatanggap ng mga notipikasyon para sa offer na ito.`)
};

const fr_offerdetail_notifications_enablepushdescription3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous devez activer les notifications push pour recevoir des notifications pour cette offre.`)
};

const it_offerdetail_notifications_enablepushdescription3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devi abilitare le notifiche push per ricevere notifiche per questa offerta.`)
};

const hu_offerdetail_notifications_enablepushdescription3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Engedélyezned kell a push értesítéseket, hogy értesítéseket kapj ehhez az ajánlathoz.`)
};

const nl_offerdetail_notifications_enablepushdescription3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je moet pushmeldingen inschakelen om meldingen voor dit aanbod te ontvangen.`)
};

const no_offerdetail_notifications_enablepushdescription3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du må aktivere push-varsler for å motta varsler for dette tilbudet.`)
};

const pl_offerdetail_notifications_enablepushdescription3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Musisz włączyć powiadomienia push, aby otrzymywać powiadomienia dla tej oferty.`)
};

const pt_br2_offerdetail_notifications_enablepushdescription3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você precisa ativar as notificações push para receber notificações deste conteúdo.`)
};

const pt_offerdetail_notifications_enablepushdescription3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precisa de ativar as notificações push para receber notificações desta oferta.`)
};

const ro_offerdetail_notifications_enablepushdescription3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trebuie să activezi notificările push pentru a primi notificări pentru această ofertă.`)
};

const fi_offerdetail_notifications_enablepushdescription3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinun on otettava push-ilmoitukset käyttöön saadaksesi ilmoituksia tästä tarjouksesta.`)
};

const sv_offerdetail_notifications_enablepushdescription3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du måste aktivera push-notiser för att få notiser för detta erbjudande.`)
};

const vi_offerdetail_notifications_enablepushdescription3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn cần bật thông báo đẩy để nhận thông báo cho ưu đãi này.`)
};

const tr_offerdetail_notifications_enablepushdescription3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu teklif için bildirim almak üzere push bildirimlerini etkinleştirmeniz gerekiyor.`)
};

const cs_offerdetail_notifications_enablepushdescription3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro příjem oznámení k této nabídce musíte povolit push oznámení.`)
};

const bg_offerdetail_notifications_enablepushdescription3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Трябва да активирате push известията, за да получавате известия за тази оферта.`)
};

const ru_offerdetail_notifications_enablepushdescription3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вам нужно включить push-уведомления, чтобы получать уведомления для этого предложения.`)
};

const uk_offerdetail_notifications_enablepushdescription3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вам потрібно ввімкнути push-сповіщення, щоб отримувати сповіщення для цієї пропозиції.`)
};

const ar_offerdetail_notifications_enablepushdescription3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحتاج إلى تمكين الإشعارات الفورية لتلقي إشعارات لهذا العرض.`)
};

const hi_offerdetail_notifications_enablepushdescription3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस ऑफ़र के लिए सूचनाएँ प्राप्त करने हेतु आपको पुश सूचनाएँ सक्षम करनी होंगी।`)
};

const th_offerdetail_notifications_enablepushdescription3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณต้องเปิดใช้งานการแจ้งเตือนแบบพุชเพื่อรับการแจ้งเตือนสำหรับข้อเสนอนี้`)
};

const ja_offerdetail_notifications_enablepushdescription3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このオファーの通知を受け取るには、プッシュ通知を有効にする必要があります。`)
};

const zh_cn2_offerdetail_notifications_enablepushdescription3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您需要开启推送通知以接收此目录项的相关更新。`)
};

const zh_hant1_offerdetail_notifications_enablepushdescription3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您需要開啟推播通知以接收此目錄項目的相關更新。`)
};

const ko_offerdetail_notifications_enablepushdescription3 = /** @type {(inputs: Offerdetail_Notifications_Enablepushdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 오퍼에 대한 알림을 받으려면 푸시 알림을 활성화해야 합니다.`)
};

/**
* | output |
* | --- |
* | "You need to enable push notifications to receive notifications for this offer." |
*
* @param {Offerdetail_Notifications_Enablepushdescription3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_notifications_enablepushdescription3 = /** @type {((inputs?: Offerdetail_Notifications_Enablepushdescription3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Notifications_Enablepushdescription3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_notifications_enablepushdescription3(inputs)
	if (locale === "ms") return ms_offerdetail_notifications_enablepushdescription3(inputs)
	if (locale === "da") return da_offerdetail_notifications_enablepushdescription3(inputs)
	if (locale === "de") return de_offerdetail_notifications_enablepushdescription3(inputs)
	if (locale === "en-US") return en_us2_offerdetail_notifications_enablepushdescription3(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_notifications_enablepushdescription3(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_notifications_enablepushdescription3(inputs)
	if (locale === "fil") return fil_offerdetail_notifications_enablepushdescription3(inputs)
	if (locale === "fr") return fr_offerdetail_notifications_enablepushdescription3(inputs)
	if (locale === "it") return it_offerdetail_notifications_enablepushdescription3(inputs)
	if (locale === "hu") return hu_offerdetail_notifications_enablepushdescription3(inputs)
	if (locale === "nl") return nl_offerdetail_notifications_enablepushdescription3(inputs)
	if (locale === "no") return no_offerdetail_notifications_enablepushdescription3(inputs)
	if (locale === "pl") return pl_offerdetail_notifications_enablepushdescription3(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_notifications_enablepushdescription3(inputs)
	if (locale === "pt") return pt_offerdetail_notifications_enablepushdescription3(inputs)
	if (locale === "ro") return ro_offerdetail_notifications_enablepushdescription3(inputs)
	if (locale === "fi") return fi_offerdetail_notifications_enablepushdescription3(inputs)
	if (locale === "sv") return sv_offerdetail_notifications_enablepushdescription3(inputs)
	if (locale === "vi") return vi_offerdetail_notifications_enablepushdescription3(inputs)
	if (locale === "tr") return tr_offerdetail_notifications_enablepushdescription3(inputs)
	if (locale === "cs") return cs_offerdetail_notifications_enablepushdescription3(inputs)
	if (locale === "bg") return bg_offerdetail_notifications_enablepushdescription3(inputs)
	if (locale === "ru") return ru_offerdetail_notifications_enablepushdescription3(inputs)
	if (locale === "uk") return uk_offerdetail_notifications_enablepushdescription3(inputs)
	if (locale === "ar") return ar_offerdetail_notifications_enablepushdescription3(inputs)
	if (locale === "hi") return hi_offerdetail_notifications_enablepushdescription3(inputs)
	if (locale === "th") return th_offerdetail_notifications_enablepushdescription3(inputs)
	if (locale === "ja") return ja_offerdetail_notifications_enablepushdescription3(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_notifications_enablepushdescription3(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_notifications_enablepushdescription3(inputs)
	return ko_offerdetail_notifications_enablepushdescription3(inputs)
});
export { offerdetail_notifications_enablepushdescription3 as "offerDetail.notifications.enablePushDescription" }